import React, { Component } from 'react'
import injectSheet from 'react-jss'
import cx from 'classnames'
import qs from 'qs'
import _ from 'lodash'
import * as moment from 'moment'
import { Flex, ActivityIndicator, Modal } from 'antd-mobile'
import Select from 'react-select'
import GooglePlacesAutocomplete, { geocodeByAddress, getLatLng } from 'react-google-places-autocomplete'

import styles from 'assets/styles/components/TakeawaySummary'
import helpers from 'helpers'
import { MerchantShipping } from 'models/merchant'
import {
  AVAILABLE_DROPOFF_LOCATIONS,
  YEUNGWOOTONG_PICKUP_LOCATIONS,
  DELIVERY_TYPE_SHOP,
  DELIVERY_TYPE_DELIVERY,
  DELIVERY_TYPE_STOREDELIVERY,
  DELIVERY_TYPE_TAKEAWAY,
  MERCHANT_YEUNGWOOTONG,
  MERCHANT_BETA_PAK,
  MERCHANT_WING3,
} from 'constants/merchant'
import { DISTRICT_MAP } from 'constants/delivery'
import * as appConstants from 'constants/app'

import Toast from './Toast'
import withToast from './hoc/Toast'
import DialogComponent from 'containers/hoc/Dialog'
import TakeawayOrderDetailList from 'containers/components/TakeawayOrderDetailList'
import NavBarContainer from 'containers/components/NavBar'

const ToastComponent = withToast(Toast)

class TakeawayOrderSummaryComponent extends Component {
  constructor (props) {
    super(props)

    this.state = {
      innerHeight: window.innerHeight - 47 - 70,
      isSubmitPayment: false,
      isLoadingTimeslot: true,
      timeslots: [],
      refreshTimeSlotsHandle: null,
      isTimeslotLoaded: false,
      isRenderToast: false,
      toastMessage: '',
      toastType: 'fail',
      showTakeawayAddressInput: false,
      showDeliveryAddressInput: this.props.deliveryType === DELIVERY_TYPE_DELIVERY,
      showDeliveryNameInput: this.props.deliveryType === DELIVERY_TYPE_DELIVERY,
      showShippingDetail: false,
      shopShippingDate: this.props.pickupAt,
      shopShippingTime: 'please_select_date',
      // selectedShippingId: 'please_select',
      isRenderDialog: false,
      promocodeMinOrderAmount: 0,
      floor: '',
      // dialogMessage: '',
      shipping: {},
      quotationStatus: '',
    }
  }

  backToDirectory=() => {
    const { merchant } = this.props
    if (!merchant) { return }

    const params = qs.stringify({
      m: merchant.id,
      dir: true,
    })
    window.location.href = `${window.location.protocol}//${window.location.host}?${params}`
  }

  resizeDimension = () => {
    this.setState({
      innerHeight: window.innerHeight - 47 - 70,
    })
  }

  componentDidMount = async () => {
    window.addEventListener('resize', this.resizeDimension)
    if (this.props.merchant) {
      this.init()
    }
  }

  componentDidUpdate = (prevProps, prevState) => {
    const { merchant } = this.props
    if (merchant && prevProps.merchant !== merchant) {
      this.init()
    }

    // > 如果沒有找到可用的 shipping 顯示 dialog
    if (typeof prevState.shipping === 'object' && !this.state.shipping) {
      this.renderNoAvailableShippingDialog()
    }
  }

  componentWillUnmount = () => {
    window.removeEventListener('resize', this.resizeDimension)
    if (this.state.refreshTimeSlotsHandle != null) {
      clearInterval(this.state.refreshTimeSlotsHandle)
    }
  }

  init = async () => {
    const { form, basket, merchant } = this.props
    let promocodes = []

    // reset basket.shipping
    if (basket.shipping) {
      this.props.setShipping(null)
    }

    if (form.datetime) {
      this.props.updateParentState({ pickupAt: form.datetime })
    } else {
      this.refreshTimeslots()
      this.setRefreshTimeSlotsJob()
    }

    if (this.props.promocodes) {
      promocodes = this.props.promocodes.split(',')
    }

    if (promocodes.length) {
      this.props.removePromoCode()
    } else if (basket.promoCode) {
      this.validatePromocode()
    }

    // if (_.get(basket, 'shipping.key')) {
    //   const isSelectedShippingIdValid = this.getAvailableShipping().map(s => s.key).includes(basket.shipping.key)
    //   if (isSelectedShippingIdValid) {
    //     this.setState({
    //       selectedShippingId: this.props.basket.shipping.key,
    //     })
    //   }
    // }

    // > get geocodeResult, directionResult and priceReult by previous address.
    if (basket.isStoreDelivery) {
      this.handleAddressSelected()
    }

    if (merchant.setting.takeawayAddress) {
      this.setState({
        showTakeawayAddressInput: true,
      })
    }
  }

  validatePromocode = async () => {
    const promocodeResult = await this.props.redeemPromoCode({
      merchantId: this.props.merchant.id,
      promoCode: this.props.basket.promoCode,
    })
    if (_.get(promocodeResult, 'success')) {
      const { total } = helpers.calculate.calculateOrders(
        this.props.orders,
        this.props.merchant,
      )
      if (total < promocodeResult.data.minOrderAmount) {
        this.setState({
          isRenderDialog: true,
          promocodeMinOrderAmount: promocodeResult.data.minOrderAmount,
        })
      }
    }
  }

  setRefreshTimeSlotsJob = () => {
    if (!this.state.refreshTimeSlotsHandle) {
      const refreshTimeSlotsHandle = setInterval(() => { this.refreshTimeslots() }, 6000)
      this.setState({ refreshTimeSlotsHandle })
    }
  }

  refreshTimeslots = async () => {
    const {
      merchant,
      pickupAt,
      getTimeslot,
      setTakeawayAvailable,
      updateParentState,
    } = this.props

    if (!merchant) return

    try {
      const res = await getTimeslot(merchant.id)
      // if no available timeslot
      if (res.length === 0) {
        await setTakeawayAvailable(false)
      } else {
        await setTakeawayAvailable(true)

        if (this.state.timeslots[0] !== res[0]) {
          this.setState({
            timeslots: res,
          })
        }
      }

      // check current pickupat value and select the closest
      if (pickupAt) {
        let closestTimeslot = ''
        let minDiff = 1000000

        res.forEach((ele) => {
          const tmp = Math.abs(moment(ele).diff(pickupAt, 'minutes'))

          if (tmp < minDiff) {
            closestTimeslot = ele
            minDiff = tmp
          }
        })

        if (moment(pickupAt).isBefore(moment(closestTimeslot))) {
          updateParentState({ pickupAt: closestTimeslot })
          this.setState({
            pickupAt: closestTimeslot,
          })
        }
      } else {
        // set initial pickUpAt value if not selected
        updateParentState({ pickupAt: res[0] })
      }
      this.setState({
        isTimeslotLoaded: true,
      })
    } catch (err) {
      this.setState({
        timeslots: [],
      })
    }
  }

  isValidTel = (tel) => {
    const isnum = /^\d+$/.test(tel)
    return tel.length === 8 && isnum
  }

  getAvailableShipping = () => {
    const { merchant, basket } = this.props
    if (!merchant) { return [] }
    const availableShippings = _.filter(merchant.shippings, (o) => {
      const shipping = new MerchantShipping(o)
      let type
      if (basket.isShop) {
        type = 'shop'
        return shipping.type === 'shop' && shipping.enabled
      }
      if (basket.isStoreDelivery) {
        type = 'storeDelivery'
        if (!this.props.pickupAt) {
          return false
        }
        return shipping.isAvailable(type, this.props.pickupAt)
      }
      return false
    })
    return availableShippings
  }

  handleAddressSelected = async (e, options) => {
    console.log('handleAddressSelected', e && e.value)
    if (!window.google) {
      setTimeout(() => this.handleAddressSelected(e, options), 1000)
      return
    }

    this.setState({ quotationStatus: 'processing' })

    try {
      const { locale, merchant, form, user, basket, orders } = this.props
      const { total } = helpers.calculate.calculateOrders(
        orders,
        merchant,
        _.get(basket, 'discount'),
      )

      let pickupAt = (options && options.pickupAt) ? options.pickupAt : this.props.pickupAt
      const address = e ? e.value.description : user.address
      const geocodeResult = await geocodeByAddress(address)
      const country = await helpers.googleMap.findCountry(geocodeResult[0])
      const destination = await getLatLng(geocodeResult[0])
      const origin = await helpers.googleMap.getOriginLatLng({ location: merchant.setting.location, address: merchant.address })
      console.log('geocodeByAddress', { geocodeResult, origin, destination })

      const directionResult = await helpers.googleMap.getDirectionResult({ origin, destination })
      const duration = directionResult.routes[0].legs[0].duration // e.g. { text: "14 分鐘", value: 827 }
      console.log('getDirectionResult', { directionResult, duration })

      const start = { lat: String(origin.lat), lng: String(origin.lng), address: merchant.address, country }
      const end = { lat: String(destination.lat), lng: String(destination.lng), address, country }

      const shippings = _.filter(merchant.shippings, s => s.type === (basket.isShop ? 'shop' : 'storeDelivery') && s.enabled)
      const shipping = _.clone(shippings[0])

      const preparingTime = shipping ? shipping.minDeliveryMinute : 0
      const shippingTime = duration ? Math.ceil(duration.value / 60) : 0
      const bufferTime = appConstants.LALAMOVE_BUFFER
      const deliveryTime = preparingTime + shippingTime + bufferTime
      const immediate = moment().add(deliveryTime, 'minutes').toISOString()
      const isOverTime = moment(pickupAt).isSameOrBefore(moment(immediate))

      // 如果 getQuotation 的時候超時的話改用即時
      if (isOverTime || !pickupAt) {
        pickupAt = moment(immediate).clone()
        this.props.updateParentState({ pickupAt: immediate })
      }

      const scheduleAt = (
        isOverTime ? moment(immediate) : moment(pickupAt)
      ).subtract(deliveryTime, 'minutes')
        .add(preparingTime, 'minutes')
        .add(1, 'minutes')

      console.table({
        isOverTime: isOverTime,
        immediate: moment(immediate).format('YYYY-MM-DD hh:mm:ss'),
        pickupAt: moment(pickupAt).format('YYYY-MM-DD hh:mm:ss'),
        scheduleAt: moment(scheduleAt).format('YYYY-MM-DD hh:mm:ss'),
        datetime: moment(form.datetime).format('YYYY-MM-DD hh:mm:ss'),
      })

      const params = {
        locale,
        pickupAt: isOverTime ? immediate : pickupAt,
        scheduleAt: scheduleAt.toISOString(),
        waypoints: [start, end],
        requesterContact: { name: merchant.name, phone: merchant.contact },
        orderAmount: total,
        merchantId: merchant.id,
      }
      const priceResult = await helpers.lalamovePricing.getLalamoveQuotation(params)
      const district = helpers.lalamovePricing.findDistrict(priceResult.stops, address)
      const area = shipping.areas.find(area => area.district === district) || shipping.areas.find(area => area.isDefault)
      const isLalamove = merchant.setting.lalamove

      shipping.areas = [area]
      shipping.totalFee = isLalamove
        ? (area.price !== null) ? area.price : priceResult.totalFee
        : (area.price !== null) ? area.price : shipping.cost

      console.log('getLalamoveQuotation', { priceResult, district, shipping })
      this.setState({ shipping }) // if no available shipping, render a dialog.
      this.props.setShipping({ ...priceResult, ...shipping })
      this.props.updateParentState({
        ...destination,
        address,
        district,
        pickupAt: priceResult.pickupAt,
      })
    } catch (error) {
      console.log('handleAddressSelected error', error)
      this.renderGetQuotationErrorAlert()
    }

    this.setState({ quotationStatus: 'done' })
  }

  renderSummary () {
    const {
      tel,
      promoCode,
      name,
      takeawayOrders,
      intl,
      classes,
      merchant,
      updateParentState,
      basket,
      // orders,
      // setShipping,
      address,
      floorRoom,
      companyBuilding,
      user,
    } = this.props

    if (!merchant) return <div />

    const _restaurantInfoText = intl.formatMessage({ id: 'summary.restaurant.info' })
    const _timeText = intl.formatMessage({ id: 'summary.time' })
    // const _dateText = intl.formatMessage({ id: 'summary.date' })
    const _nameText = intl.formatMessage({ id: 'summary.restaurant.info.name' })
    const _addressText = intl.formatMessage({ id: 'summary.restaurant.info.address' })
    const _floorRoomText = intl.formatMessage({ id: 'summary.floorRoom' })
    const _companyBuildingText = intl.formatMessage({ id: 'summary.companyBuilding' })
    const _userNameText = intl.formatMessage({ id: 'summary.name' })
    const _telText = intl.formatMessage({ id: 'summary.restaurant.info.tel' })
    const _telPlaceholderText = intl.formatMessage({ id: 'summary.tel_placeholder' })
    // const _pleaseSelectShippingText = intl.formatMessage({ id: 'shipping.please_select_shipping' })
    // const _minimunCharge = intl.formatMessage({ id: 'shipping.minimun_charge' })
    const _requiredText = intl.formatMessage({ id: 'summary.required' })

    const containerStyle = cx(classes['takeaway-summary-info-container'])
    const headerStyle = cx(classes['takeaway-summary-header'])
    const subHeaderStyle = cx(classes['takeaway-summary-sub-header'])
    const bgShapeCheckoutStyle = cx(classes['bg-shape'], classes['bg-shape-checkout'])
    const telInputValidStyle = cx(classes['takeaway-summary-tel-input'], classes['takeaway-summary-tel-input-valid'])
    const telInputInvalidStyle = cx(classes['takeaway-summary-tel-input'], classes['takeaway-summary-tel-input-invalid'])
    const telInputStyle = this.isValidTel(tel) ? telInputValidStyle : telInputInvalidStyle
    const addressInputStyle = cx(classes['takeaway-summary-address-input'])
    const addressOptionalInputStyle = cx(classes['takeaway-summary-address-optional-input'])
    const timeSelectStyle = cx(classes['takeaway-summary-time-select'])
    const shopDateSelectStyle = cx(classes['takeaway-summary-shop-date-select'])
    const shopTimeSelectStyle = cx(classes['takeaway-summary-shop-time-select'])
    const loadingStyle = cx(classes['loading-sign'])
    const deliverySelectContainerStyle = cx(classes['delivery-select-container'])
    const divider = cx(classes.divider)
    // const shippings = merchant.shippings || []
    // const selectedShipping = shippings.find(shipping => shipping.key === this.state.selectedShippingId)
    // if (this.state.selectedShippingId && this.state.selectedShippingId !== 'please_select' && !selectedShipping) {
    // FIXME: bug when change merchant
    // return this.backToDirectory()
    // }
    // const renderAvailableShippingOptions = () => {
    //   const { total: totalAmount } = helpers.calculate.calculateOrders(
    //     this.props.orders,
    //     this.props.merchant,
    //   )
    //   const availableShippings = this.getAvailableShipping()

    //   if (this.props.pickupAt && merchant && availableShippings.length === 0) {
    //     return this.backToDirectory()
    //   }

    //   if (availableShippings.length === 0) return <option key='no_available_option' value='no_available_option' >無適用外送服務</option>
    //   const options = availableShippings.map((shipping, index) => {
    //     const { name, minAmount, cost } = shipping
    //     if (totalAmount < minAmount) {
    //       const option = `${name} ($${cost}) ${_minimunCharge} $${minAmount}`
    //       return <option key={index} value={shipping.key} disabled='disabled'>{option}</option>
    //     } else if (totalAmount >= minAmount) {
    //       const option = `${name} ($${cost})`
    //       return <option key={index} value={shipping.key}>{option}</option>
    //     } else {
    //       return null
    //     }
    //   }).filter(o => o)
    //   if (options.length) {
    //     options.push(<option key='please_select' value='please_select' hidden disabled>
    //       {_pleaseSelectShippingText}
    //     </option>)
    //   } else {
    //     options.push(<option key='please_select' value='please_select' disabled>
    //       {intl.formatMessage({ id: 'shipping.no_available_shipping' })}
    //     </option>)
    //   }
    //   return options
    // }

    const renderRestaurantInfo = () => {
      return (
        <React.Fragment>
          <div className={headerStyle} style={{ position: 'relative' }}>
            <div className={bgShapeCheckoutStyle} />
            {_restaurantInfoText}
          </div>

          <div className={subHeaderStyle}>{_nameText}</div>
          <div>{merchant.name}</div>

          <div className={subHeaderStyle}>{_addressText}</div>
          <div>{merchant.address}</div>

          {/* <div className={subHeaderStyle}>{_telText}</div>
          <a href={'tel:' + merchant.contact}>{merchant.contact}</a> */}
        </React.Fragment>
      )
    }

    const renderTakeawayTimeSlotSelector = () => {
      return (
        <React.Fragment>
          <div className={divider} />
          <div className={headerStyle} style={{ position: 'relative' }}>
            <div className={bgShapeCheckoutStyle} />
            {_timeText}
          </div>
          {
            [DELIVERY_TYPE_TAKEAWAY, DELIVERY_TYPE_STOREDELIVERY].includes(this.props.deliveryType) &&
            <div>
              {this.state.timeslots.length === 0 &&
                  <ActivityIndicator size='large' className={loadingStyle} />}
              {this.state.timeslots.length > 0 &&
                  <select
                    className={timeSelectStyle}
                    value={this.props.pickupAt}
                    onChange={(e) => {
                      this.props.updateParentState({ pickupAt: e.target.value })
                    }}
                  >
                    {this.state.timeslots.map(ele => {
                      return (
                        <option key={ele} value={ele}>
                          {helpers.date.getTimeslotFormat(ele, intl.locale)}
                        </option>
                      )
                    })}
                  </select>}
            </div>
          }
        </React.Fragment>
      )
    }

    const renderShopTimeSlotSelector = () => {
      // const {
      //   selectedShippingId,
      // } = this.state
      const {
        intl,
        merchant,
      } = this.props

      const _pleaseSelectDateText = intl.formatMessage({ id: 'shipping.please_select_date' })
      const _pleaseSelectPeriodText = intl.formatMessage({ id: 'shipping.please_select_period' })

      // const shipping = merchant.shippings.filter(s => s.key === selectedShippingId)[0]
      // if (!shipping) { return false }
      // const minDeliveryHours = shipping.minDeliveryHour
      // const maxDeliveryHours = shipping.maxDeliveryHour
      const shopShippings = merchant && merchant.shippings && merchant.shippings.filter(s => s.type === 'shop' && s.enabled)
      const minDeliveryHour = _.minBy(shopShippings, 'minDeliveryHour').minDeliveryHour
      const maxDeliveryHour = _.maxBy(shopShippings, 'maxDeliveryHour').maxDeliveryHour

      const duration = helpers.date.getShopDeliveryTimeSlot(moment(), minDeliveryHour, maxDeliveryHour)

      const {
        minDeliveryStart,
        maxDeliveryStart,
      } = duration

      const minDate = minDeliveryStart.format('YYYY-MM-DD')
      const maxDate = maxDeliveryStart.format('YYYY-MM-DD')

      const renderTimeSlotOptions = () => {
        const options = [
          <option disabled hidden key='1' value='please_select_date'>{_pleaseSelectDateText}</option>,
          <option disabled hidden key='2' value='please_select_time'>{_pleaseSelectPeriodText}</option>,
          <option key='3' value='10:00'>10:00 ~ 13:00</option>,
          <option key='4' value='14:00'>14:00 ~ 18:00</option>,
        ]
        if (
          (this.state.shopShippingDate === minDate) &&
          (minDeliveryStart.isSame(moment(minDate).add(14, 'hours')))
        ) {
          options.splice(2, 1)
        } else if (
          (this.state.shopShippingDate === maxDate) &&
          (maxDeliveryStart.isSame(moment(maxDate).add(10, 'hours')))
        ) {
          options.splice(3, 1)
        }
        return options
      }

      return (
        <React.Fragment>
          <div className={divider} />
          <div className={headerStyle} style={{ position: 'relative' }}>
            <div className={bgShapeCheckoutStyle} />
            {_timeText}
          </div>

          <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
            <React.Fragment>
              <input
                className={shopDateSelectStyle}
                type='date'
                min={minDate}
                max={maxDate}
                value={this.state.shopShippingDate}
                onChange={(e) => {
                  this.props.updateParentState({ selectedTimeslot: false })
                  this.setState({ shopShippingTime: 'please_select_date' })
                  this.setState({ shopShippingDate: e.target.value }, () => {
                    if (this.state.shopShippingTime === 'please_select_date') {
                      this.setState({ shopShippingTime: 'please_select_time' })
                    }
                  })
                }}
              />

              <select
                className={shopTimeSelectStyle}
                disabled={!this.state.shopShippingDate}
                value={this.state.shopShippingTime}
                onChange={e => {
                  this.setState({ shopShippingTime: e.target.value })
                  const pickupAt = moment(`${this.state.shopShippingDate} ${e.target.value}`).toISOString()
                  this.props.updateParentState({
                    pickupAt,
                    selectedTimeslot: true,
                  })
                  this.handleAddressSelected(undefined, { pickupAt })
                }}
              >
                {renderTimeSlotOptions()}
              </select>

            </React.Fragment>
          </div>

        </React.Fragment>
      )
    }

    const renderStoreDeliveryTimeSlot = () => {
      const { intl, form, pickupAt } = this.props
      const rechooseText = intl.formatMessage({ id: 'takeaway.rechoose' })
      const fromDatetime = form.immediate ? moment() : form.datetime
      const time = pickupAt ? moment(pickupAt) : moment(fromDatetime)

      return (
        <React.Fragment>
          <div className={divider} />
          <div className={headerStyle} style={{ position: 'relative' }}>
            <div className={bgShapeCheckoutStyle} />
            {_timeText}
          </div>

          <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', lineHeight: '24px' }}>
            {time.format('LL dddd LT')}
            <p onClick={() => this.backToDirectory()}>
              {rechooseText}
            </p>
          </div>

        </React.Fragment>
      )
    }

    const renderDelivery = () => {
      // pickupp
      const { intl } = this.props

      const _pleaseSelectText = intl.formatMessage({ id: 'summary.please_select' })
      const _takeawayTypeText = intl.formatMessage({ id: 'summary.deliveryType.takeaway' })
      const _deliveryTypeText = intl.formatMessage({ id: 'summary.deliveryType.delivery' })

      let deliveryNameInput
      let deliveryAddressInput

      if (this.state.showDeliveryNameInput) {
        deliveryNameInput = (
          <div>
            <div
              className={headerStyle}
              style={{ position: 'relative' }}
            >
              <div className={bgShapeCheckoutStyle} />
              {_userNameText}
            </div>
            <Flex>
              <Flex.Item style={{ marginTop: '0px', top: '0px' }}>
                <input
                  className={addressInputStyle}
                  value={name}
                  onChange={(e) => updateParentState({ name: e.target.value })}
                />
              </Flex.Item>
            </Flex>
          </div>
        )
      }

      if (this.state.showDeliveryAddressInput) {
        const options = AVAILABLE_DROPOFF_LOCATIONS.map(location => {
          return {
            value: `${location.name} ${location.address}`,
            label: location.name,
          }
        })

        deliveryAddressInput = (
          <div>
            <div
              className={headerStyle}
              style={{ position: 'relative' }}
            >
              <div className={bgShapeCheckoutStyle} />
              {_addressText}
            </div>
            <Flex className={deliverySelectContainerStyle}>
              <Flex.Item style={{ marginTop: '0px', top: '0px' }}>
                <Select
                  value={{
                    value: this.props.deliveryAddress,
                    label: this.props.deliveryAddressName,
                  }}
                  placeholder={_pleaseSelectText}
                  options={options}
                  noOptionsMessage={() => ''}
                  onChange={(data, actionMeta) => {
                    if (actionMeta.action === 'select-option') {
                      updateParentState({
                        deliveryAddress: data.value,
                        deliveryAddressName: data.label,
                      })
                    }
                  }}
                />
                {/* <select
                  value={this.props.deliveryAddress}
                  onChange={(e) => {
                    updateParentState({ deliveryAddress: e.target.value })
                  }}
                  className={timeSelectStyle}
                >
                  <option value='' disabled>--請選擇--</option>
                  {
                    AVAILABLE_DROPOFF_LOCATIONS.map((location, i) => {
                      return <option key={i} value={location.name + ' ' + location.address}>{location.name}</option>
                    })
                  }
                </select> */}
              </Flex.Item>
            </Flex>
          </div>
        )
      }

      return (
        <div
          style={{
            borderBottom: '1px solid #e5e5e5',
            padding: '0px 0px 15px 0',
            marginBottom: '15px',
            position: 'relative',
          }}
        >
          <div className={headerStyle}>
            <div className={bgShapeCheckoutStyle} />
            {_deliveryTypeText}
          </div>
          <div style={{ fontSize: '14px' }}>
            {/* 配送方式 */}
            <select
              className={timeSelectStyle}
              value={this.props.deliveryType}
              onChange={(e) => {
                updateParentState({
                  deliveryType: e.target.value,
                })
                this.setState({
                  showDeliveryAddressInput: e.target.value === DELIVERY_TYPE_DELIVERY,
                  showDeliveryNameInput: e.target.value === DELIVERY_TYPE_DELIVERY,
                })
              }}
            >
              {basket.isDeliveryAvailable && <option value={DELIVERY_TYPE_DELIVERY}>{_deliveryTypeText}</option>}
              {basket.isTakeawayAvailable && <option value={DELIVERY_TYPE_TAKEAWAY}>{_takeawayTypeText}</option>}
            </select>
            {/* {deliveryCheckbox} */}
            {deliveryNameInput}
            {deliveryAddressInput}
          </div>
        </div>
      )
    }

    const renderDropoff = () => {
      return (
        <Flex>
          <Flex.Item style={{ marginTop: '0px', top: '0px' }}>
            <div>
              <select
                className={timeSelectStyle}
                value={this.props.dropoffat}
                onChange={(e) => {
                  updateParentState({ dropoffat: e.target.value })
                }}
              >
                {this.props.getDeliveryTimeslot().map((ele) => {
                  return (
                    <option key={ele.format()} value={ele.format()}>
                      {helpers.date.getTimeslotFormat(moment(ele).clone().subtract(15, 'minute'), intl.locale, true)} - {ele.format('HH:mm')}
                    </option>
                  )
                })}
              </select>
            </div>
          </Flex.Item>
        </Flex>
      )
    }

    const renderShipping = () => {
      const _headerText = intl.formatMessage({ id: 'shipping.shipping_service' })
      const _addressPlaceholderText = intl.formatMessage({ id: 'shipping.please_fill_address' })
      const _noOptionsMessageText = intl.formatMessage({ id: 'shipping.no_options_message' })
      const loadingMessageText = intl.formatMessage({ id: 'loading' })

      return (
        <React.Fragment>
          <div className={divider} />
          <div className={headerStyle} style={{ position: 'relative' }}>
            <div className={bgShapeCheckoutStyle} />
            { _headerText}
          </div>
          {/* Address Input */}
          <div className={subHeaderStyle}>
            {`${_addressText}: `}{_requiredText}
          </div>
          <GooglePlacesAutocomplete
          // apiKey={API_KEY}
            debounce={300}
            selectProps={{
              placeholder: `${_addressPlaceholderText}...`,
              onChange: this.handleAddressSelected,
              defaultInputValue: user.address,
              loadingMessage: () => {
                return <span>{loadingMessageText}</span>
              },
              noOptionsMessage: () => {
                if (!user.address || this.props.address) {
                  return null
                }
                return <span>{_noOptionsMessageText}</span>
              },
            }}
            autocompletionRequest={{
              componentRestrictions: {
                country: ['hk'],
              },
            }}
          />

          <div className={subHeaderStyle}>
            {`${_floorRoomText}:`}
          </div>
          <textarea
            className={addressOptionalInputStyle}
            style={{ resize: 'none' }}
            maxLength='200'
            rows='1'
            value={floorRoom}
            onChange={(e) => updateParentState({ floorRoom: e.target.value })}
          />

          <div className={subHeaderStyle}>
            {`${_companyBuildingText}:`}
          </div>
          <textarea
            className={addressOptionalInputStyle}
            style={{ resize: 'none' }}
            maxLength='200'
            rows='1'
            value={companyBuilding}
            onChange={(e) => updateParentState({ companyBuilding: e.target.value })}
          />

        </React.Fragment>
      )
    }

    const renderNameInput = () => {
      return (
        <div>
          <div className={subHeaderStyle}>
            {`${_userNameText}: `}{_requiredText}
          </div>
          <Flex>
            <Flex.Item style={{ marginTop: '0px', top: '0px' }}>
              <input
                className={addressInputStyle}
                value={name}
                maxLength='30'
                onChange={(e) => updateParentState({ name: e.target.value })}
              />
            </Flex.Item>
          </Flex>
        </div>
      )
    }

    const renderTelInput = () => {
      return (
        <React.Fragment>
          <div className={subHeaderStyle}>
            {`${_telText}: `}{_requiredText}
          </div>
          <div style={{ display: 'flex', alignItems: 'center' }}>
            <span>+852</span>
            <input
              style={{ flex: 1 }}
              className={telInputStyle}
              placeholder={_telPlaceholderText}
              maxLength='8'
              onChange={(e) => this.props.updateParentState({ tel: e.target.value })} value={tel}
            />
          </div>
        </React.Fragment>
      )
    }

    const renderTableware = () => {
      const { intl, needTableware, updateParentState } = this.props

      const needTablewareText = intl.formatMessage({ id: 'takeaway.needTableware' })
      const requiredText = intl.formatMessage({ id: 'required' })
      const notRequiredText = intl.formatMessage({ id: 'notRequired' })

      const handleChange = (e) => {
        const toBoolean = () => {
          if (typeof (e.target.value) === 'string') {
            if (e.target.value === 'true') return true
            return false
          }
        }
        updateParentState({ needTableware: toBoolean(e.target.value) })
      }
      return (
        <React.Fragment>
          <div className={subHeaderStyle}>
            {needTablewareText}
          </div>
          <div style={{ display: 'flex', alignItems: 'center' }}>
            <label style={{ marginRight: 10, marginTop: 10 }}>
              <input
                type='radio'
                name="tableware"
                value={true}
                checked={needTableware}
                onChange={handleChange}
                style={{
                  position: 'static',
                  marginRight: 5,
                }}
              />
              {requiredText}
            </label>
            <label style={{ marginRight: 10, marginTop: 10 }}>
              <input
                type='radio'
                name="tableware"
                value={false}
                checked={!needTableware}
                onChange={handleChange}
                style={{
                  position: 'static',
                  marginRight: 5,
                }}
              />
              {notRequiredText}
            </label>
          </div>
        </React.Fragment>
      )
    }

    const renderAddressInput = () => {
      const { intl, merchant } = this.props

      let options = []
      if (
        // TODO: pak and wing3 to select address
        [MERCHANT_YEUNGWOOTONG, MERCHANT_BETA_PAK, MERCHANT_WING3].includes(merchant.id)
      ) {
        options = YEUNGWOOTONG_PICKUP_LOCATIONS.map(location => {
          return {
            value: `${location.address}`,
            label: location.address,
          }
        })
      }
      if (options.length) {
        // render select
        return (
          <div>
            <div
              className={headerStyle}
              style={{ position: 'relative' }}
            >
              <div className={bgShapeCheckoutStyle} />
              {_addressText}
            </div>
            <Flex className={deliverySelectContainerStyle}>
              <Flex.Item style={{ marginTop: '0px', top: '0px' }}>
                <Select
                  value={{
                    value: this.props.address,
                    label: this.props.address,
                  }}
                  isSearchable={false}
                  placeholder={intl.formatMessage({ id: 'summary.please_select' })}
                  options={options}
                  noOptionsMessage={() => ''}
                  onChange={(data, actionMeta) => {
                    if (actionMeta.action === 'select-option') {
                      updateParentState({ address: data.value })
                    }
                  }}
                />
              </Flex.Item>
            </Flex>
          </div>
        )
      } else {
        const headerStyle = cx(classes['takeaway-summary-header'])
        const bgShapeCheckoutStyle = cx(classes['bg-shape'], classes['bg-shape-checkout'])
        const _addressText = intl.formatMessage({ id: 'summary.restaurant.info.address' })
        const addressInputStyle = cx(classes['takeaway-summary-address-input'])

        // render input
        return (
          <div>
            <div
              className={headerStyle}
              style={{ position: 'relative' }}
            >
              <div className={bgShapeCheckoutStyle} />
              {_addressText}
            </div>
            <Flex>
              <Flex.Item style={{ marginTop: '0px', top: '0px' }}>
                <textarea
                  className={addressInputStyle}
                  value={address}
                  onChange={(e) => updateParentState({ address: e.target.value })}
                />
              </Flex.Item>
            </Flex>
          </div>
        )
      }
    }

    return (
      <div>
        <div className={containerStyle}>
          {/* Restaurant Informations */}
          { renderRestaurantInfo() }
          {/* Delivery */}
          {/* pickupp */}
          { this.props.basket.isDelivery && renderDelivery() }
          { this.state.showTakeawayAddressInput && (!basket.isShop && !basket.isStoreDelivery) && renderAddressInput() }

          {/* Shipping (shop & storeDelivery) */}
          { basket.isShop && renderShopTimeSlotSelector() }
          { ((basket.isShop && this.props.selectedTimeslot) || basket.isStoreDelivery) && renderShipping() }

          { (basket.isTakeaway || basket.isShop || basket.isStoreDelivery) && renderNameInput() }
          { renderTelInput() }
          { (basket.isTakeaway || basket.isStoreDelivery) && renderTableware() }

          {/* Time Slot Selector */}
          {(() => {
            if (basket.isStoreDelivery || (basket.isTakeaway && this.props.form.datetime && !basket.isShop)) {
              return renderStoreDeliveryTimeSlot()
            }

            if (basket.isTakeaway && !basket.isShop) {
              return renderTakeawayTimeSlotSelector()
            }
          })()}

          {/* Dropoff */}
          {this.props.deliveryType === DELIVERY_TYPE_DELIVERY && renderDropoff()}

        </div>

        <TakeawayOrderDetailList
          deliveryType={this.props.deliveryType}
          promoCodeInput={promoCode}
          onPromoCodeFailed={(msg) => {
            this.setState({
              isRenderToast: true,
              toastMessage: msg,
            })
          }}
          onPromoCodeValueChanged={promoCode => { this.props.updateParentState({ promoCode }) }}
          takeawayOrders={takeawayOrders}
          // selectedShipping={selectedShipping}
          address={address}
        />
      </div>
    )
  }

  isValid = () => {
    const {
      tel,
      name,
      dropoffat,
      deliveryAddress,
      deliveryType,
      address,
      selectedTimeslot,
    } = this.props

    const {
      showTakeawayAddressInput,
      quotationStatus,
    } = this.state

    switch (deliveryType) {
      case DELIVERY_TYPE_TAKEAWAY:
        if (showTakeawayAddressInput) {
          if (!address) { return false }
        }
        return this.isValidTel(tel) && (this.state.isTimeslotLoaded || this.props.form.datetime) && name
      case DELIVERY_TYPE_DELIVERY:
        return this.isValidTel(tel) && dropoffat && name && deliveryAddress
      case DELIVERY_TYPE_SHOP:
        return this.isValidTel(tel) && name && address && selectedTimeslot && quotationStatus === 'done' && !_.isEmpty(this.state.shipping)
      case DELIVERY_TYPE_STOREDELIVERY:
        return this.isValidTel(tel) && name && address && quotationStatus === 'done' && !_.isEmpty(this.state.shipping)
      default:
        return false
    }
  }

  renderFooter = () => {
    const {
      intl,
      classes,
      onSubmitBtnClick,
    } = this.props
    const { quotationStatus } = this.state

    const _payText = intl.formatMessage({ id: 'footer.takeaway.confirm.pay' })
    const footerStyle = cx(classes['takeaway-summary-footer'])
    const footerInValidStyle = cx(classes['takeaway-summary-footer'], classes['takeaway-summary-footer-invalid'])
    const processingText = intl.formatMessage({ id: 'footer.processing' })

    const confirmPaymentButton = this.isValid()
      ? <div className={footerStyle} onClick={onSubmitBtnClick}>{_payText}</div>
      : <div className={footerInValidStyle}>{
        quotationStatus === 'processing'
          ? `${processingText}...`
          : _payText
      }</div>

    return confirmPaymentButton
  }

  renderHeader = () => <NavBarContainer isTakeawaySummary />

  renderToast = () => {
    if (this.state.isRenderToast) {
      return (
        <ToastComponent
          toastType={this.state.toastType}
          duration={5}
          message={this.state.toastMessage}
          callback={this.resetToast}
        />
      )
    }
  }

  renderDialog = () => {
    return (
      <DialogComponent
        triggerModal={(result) => {
          if (!result) {
            this.setState({
              isRenderDialog: false,
            })
            this.props.removePromoCode()
          } else {
            this.props.history.push('/home')
          }
        }}
        dialogType='confirm'
        confirmBtnText={this.props.intl.formatMessage({ id: 'dialog.promocode.addOrder' })}
        cancelBtnText={this.props.intl.formatMessage({ id: 'dialog.promocode.continuePay' })}
        title={this.props.intl.formatMessage(
          { id: 'dialog.promocode.lessThanMinOrderAmount' },
          { amt: this.state.promocodeMinOrderAmount },
        )}
        onClose={() => {
          console.log('onClose')
          // this.setState({
          //   isOpenWelcomeModal: false,
          // })
        }}
      />
    )
  }

  resetToast = () => {
    this.setState({
      isRenderToast: false,
      toastMessage: '',
    })
  }

  renderNoAvailableShippingDialog = () => {
    const { intl } = this.props
    const goBackButtonText = intl.formatMessage({ id: 'dialog.go_back' })
    const titleText = intl.formatMessage({ id: 'dialog.no_available_shipping.title' })
    const message = intl.formatMessage({ id: 'dialog.no_available_shipping.message' })

    const title = (<p style={{ lineHeight: 1.5, margin: 0 }}>{titleText}</p>)
    const goBackButton = {
      text: goBackButtonText,
      onPress: () => this.setState({ shipping: {} }),
    }
    const dialogButtons = [goBackButton]

    Modal.alert(title, message, dialogButtons)
  }

  renderGetQuotationErrorAlert = () => {
    const { intl } = this.props
    const goBackButtonText = intl.formatMessage({ id: 'dialog.go_back' })
    const titleText = intl.formatMessage({ id: 'dialog.get_quotation_error.title' })
    const message = intl.formatMessage({ id: 'dialog.get_quotation_error.message' })

    const title = (<p style={{ lineHeight: 1.5, margin: 0 }}>{titleText}</p>)
    const goBackButton = {
      text: goBackButtonText,
      onPress: () => {
        const params = qs.stringify({
          m: this.props.merchant.id,
          dir: true,
          ..._.get(this.props.query, 'params.pkg') && { pkg: this.props.query.params.pkg },
        })
        window.location.href = `${window.location.protocol}//${window.location.host}?${params}`
      },
    }
    const dialogButtons = [goBackButton]

    Modal.alert(title, message, dialogButtons)
  }

  render () {
    const {
      classes,
      // merchant,
    } = this.props

    const containerStyle = cx(classes['takeaway-summary-wrap'])
    // const coverContainerStyle = cx(classes['takeaway-summary-cover-container'])

    // const banner = ''
    // if (merchant != null) {
    // banner = (
    //   <img
    //     className={coverStyle}
    //     src={cloudinary.transformation(merchant.images.cover, 'h_80')}
    //     alt=''
    //   />
    // )
    // }

    return (
      <div>
        {this.renderHeader()}
        <div className={containerStyle} style={{ height: this.state.innerHeight }}>
          {/* <div className={coverContainerStyle}>{banner}</div> */}
          {this.renderSummary()}
          {/* confirm button */}
          {this.renderFooter()}
        </div>
        {this.renderToast()}
        {this.state.isRenderDialog && this.renderDialog()}
      </div>)
  }
}

export default injectSheet(styles)(TakeawayOrderSummaryComponent)



// WEBPACK FOOTER //
// ./src/components/TakeawayOrderSummary.js